/** 场景引用总线:World/dev 装配后,效果与实体从这里取到彼此(解耦)。 */
import type { Stage } from './Stage';
import type { CitizenCrowd } from '../world/Citizens';
import type { Island } from '../world/Island';
import type { FireSeed } from '../world/FireSeed';
import type { Buildings } from '../world/Buildings';

export const scene = {
  stage: null as unknown as Stage,
  crowd: null as unknown as CitizenCrowd,
  island: null as unknown as Island,
  fireSeed: null as unknown as FireSeed,
  buildings: null as unknown as Buildings,
};

export function setScene(s: Partial<typeof scene>) {
  Object.assign(scene, s);
}
